import type { TransferDetails as XpaTransferDetails } from "@motain/xpa-proto-files-web/lib/types/transfer_details";
import { TransferDetailsEntry_Highlight } from "@motain/xpa-proto-files-web/lib/types/transfer_details";
import { isNonNullable } from "@/types/isNonNullable";
import type { FC } from "react";
import styles from "./TransferDetails.module.scss";
import classNames from "classnames";
export const TransferDetails: FC<XpaTransferDetails> = (props) => {
  const { title, entries } = props;

  return (
    <div className={styles.container}>
      {isNonNullable(title) && title !== "" && (
        <p className={classNames("title-7-bold", styles.title)}>{title}</p>
      )}
      {isNonNullable(entries) && (
        <ul className={styles.list}>
          {entries.map((entry) => (
            <li
              className={styles.entry}
              key={`${entry.title}-${entry.subtitle}`}
            >
              <p
                className={classNames(
                  "title-3-bold",
                  styles.entryTitle,
                  entry.highlight === TransferDetailsEntry_Highlight.NONE &&
                    styles.grey,
                  entry.highlight === TransferDetailsEntry_Highlight.GREEN &&
                    styles.green,
                  entry.highlight === TransferDetailsEntry_Highlight.BLUE &&
                    styles.blue,
                  entry.highlight === TransferDetailsEntry_Highlight.RED &&
                    styles.red,
                )}
              >
                {entry.title}
              </p>
              <p
                className={classNames("title-7-regular", styles.entrySubtitle)}
              >
                {entry.subtitle}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
